import genererDelaiReglementDetail from './genererDelaiReglementDetail';

export default function generer() {
  const detail = genererDelaiReglementDetail();
  return {
    libelle: '',
    delaiReglementDetail: detail,
    estPersonnalisable: false,
  };
}
